var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislikeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.305,
    height: 9.808,
    viewBox: "0 0 11.305 9.808",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8110",
    "data-name": "Path 8110",
    d: "M7.133,11.2l-2.8-2.8a1.011,1.011,0,0,1-.293-.713V2.628A1.015,1.015,0,0,1,5.048,1.616H9.6a1.019,1.019,0,0,1,.931.612l1.65,3.85a1.52,1.52,0,0,1-1.4,2.115H7.927l.481,2.317A.763.763,0,0,1,8.2,11.2.753.753,0,0,1,7.133,11.2ZM2.012,1.616A1.015,1.015,0,0,1,3.024,2.628V6.676A1.012,1.012,0,0,1,1,6.676V2.628A1.015,1.015,0,0,1,2.012,1.616Z",
    transform: "translate(-1 -1.616)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikeIcon);
export default __webpack_public_path__ + "static/media/dislike_icon.bc2e83d0e552ce0f502c334be0fff31f.svg";
export { ForwardRef as ReactComponent };